import { combineReducers } from '@reduxjs/toolkit';
import manufacturerSlice from './manufacturer/manufacturerSlice';
import productModelSlice from './productModel/productModelSlice';
import productCategorySlice from './productCategory/productCategorySlice';
import customerAgreementSlice from './customerAgreement/customerAgreementSlice';
import customerProfileSlice from './customer/profileSlice';
import customerImeiSlice from './customerImei/customerimeiSlice';
import { planCompositeFormSlice } from './plan/compositePlanSlice';
import { customerPaymentFormSlice } from './customer/paymentSlice';
import dashboardSlice from './dashboard/dashboardSlice';

const rootReducer = combineReducers({
  [manufacturerSlice.name]: manufacturerSlice.reducer,
  [productModelSlice.name]: productModelSlice.reducer,
  [productCategorySlice.name]: productCategorySlice.reducer,
  [customerAgreementSlice.name]: customerAgreementSlice.reducer,
  [customerProfileSlice.name]: customerProfileSlice.reducer,
  [customerImeiSlice.name]: customerImeiSlice.reducer,
  [planCompositeFormSlice.name]: planCompositeFormSlice.reducer,
  [customerPaymentFormSlice.name]: customerPaymentFormSlice.reducer,
  [dashboardSlice.name]: dashboardSlice.reducer
});

export default rootReducer;
